export const getHours = () => {
  const hoursArray = [];
  for (let hour = 1; hour <= 24; hour++) {
    const formattedHour = hour.toString().padStart(2, '0');
    hoursArray.push(formattedHour);
  }
  return hoursArray;
};

export const getMinutesForSelect = () => {
  const minutesArray = [];
  for (let minute = 0; minute < 60; minute += 5) {
    const formattedMinute = minute.toString().padStart(2, '0');
    minutesArray.push(formattedMinute);
  }
  return minutesArray;
};
